import { Button,Anchor} from "ant-design-vue";

export const antArr = [Button,Anchor];